<onsip-password-checker [modalRef]="dialogRef" [sipAddress]="data.sipAddress">
</onsip-password-checker>
